export default __webpack_public_path__ + "static/media/head02_vi_sp.47736277.png";